module.exports = __webpack_public_path__ + "img/overview_domos_pic.b8efc268.png";